export default {
  "--color-neutral-0": "rgb(27, 25, 24)",
  "--color-neutral-10": "rgb(43, 40, 39)",
  "--color-neutral-20": "rgb(80, 75, 73)",
  "--color-neutral-30": "rgb(107, 100, 97)",
  "--color-neutral-40": "rgb(120, 112, 109)",
  "--color-neutral-50": "rgb(158, 151, 148)",
  "--color-neutral-60": "rgb(182, 177, 175)",
  "--color-neutral-70": "rgb(207, 203, 201)",
  "--color-neutral-80": "rgb(226, 224, 223)",
  "--color-neutral-85": "rgb(238, 237, 236)",
  "--color-neutral-90": "rgb(243, 242, 242)",
  "--color-neutral-95": "rgb(248, 247, 247)",
  "--color-neutral-100": "rgb(255, 255, 255)",
  "--color-primary": "rgb(255, 92, 97)",
  "--color-primary-active": "rgb(255, 71, 78)",
  "--color-primary-inverse": "rgb(255, 245, 245)",
  "--color-secondary": "rgb(49, 165, 155)",
  "--color-secondary-active": "rgb(45, 149, 141)",
  "--color-secondary-inverse": "rgb(247, 253, 252)",
  "--color-success": "rgb(79, 172, 32)",
  "--color-success-active": "rgb(88, 194, 36)",
  "--color-success-inverse": "rgb(246, 253, 242)",
  "--color-danger": "rgb(210, 45, 45)",
  "--color-danger-active": "rgb(216, 70, 70)",
  "--color-danger-inverse": "rgb(252, 242, 242)",
  "--color-warning": "rgb(230, 121, 25)",
  "--color-warning-active": "rgb(233, 137, 53)",
  "--color-warning-inverse": "rgb(253, 247, 241)",
  "--color-yellow": "rgb(245, 196, 0)",
  "--color-yellow-active": "rgb(255, 206, 10)",
  "--color-yellow-inverse": "rgb(255, 252, 240)",
  "--text-color-base": "rgb(80, 75, 73)",
  "--text-color-soft": "rgb(120, 112, 109)",
  "--text-color-softer": "rgb(182, 177, 175)",
  "--text-color-disabled": "rgb(182, 177, 175)",
  "--text-color-inverse": "rgb(248, 247, 247)",
  "--text-color-link": "rgb(255, 92, 97)",
  "--text-color-link-active": "rgb(255, 71, 78)",
  "--text-color-primary": "rgb(255, 92, 97)",
  "--text-color-primary-inverse": "rgb(255, 245, 245)",
  "--text-color-secondary": "rgb(49, 165, 155)",
  "--text-color-secondary-inverse": "rgb(247, 253, 252)",
  "--text-color-success": "rgb(79, 172, 32)",
  "--text-color-success-inverse": "rgb(246, 253, 242)",
  "--text-color-warning": "rgb(230, 121, 25)",
  "--text-color-warning-inverse": "rgb(253, 247, 241)",
  "--text-color-danger": "rgb(210, 45, 45)",
  "--text-color-danger-inverse": "rgb(252, 242, 242)",
  "--background-color-base": "rgb(255, 255, 255)",
  "--background-color-soft": "rgb(248, 247, 247)",
  "--background-color-softer": "rgb(243, 242, 242)",
  "--background-color-softer-active": "rgb(248, 247, 247)",
  "--background-color-softest": "rgb(238, 237, 236)",
  "--background-color-softest-active": "rgb(243, 242, 242)",
  "--background-color-inverse": "rgb(27, 25, 24)",
  "--background-color-inverse-soft": "rgb(43, 40, 39)",
  "--background-color-inverse-softer": "rgb(80, 75, 73)",
  "--background-color-inverse-softer-active": "rgb(107, 100, 97)",
  "--background-color-primary": "rgb(255, 92, 97)",
  "--background-color-primary-active": "rgb(255, 71, 78)",
  "--background-color-primary-inverse": "rgb(255, 245, 245)",
  "--background-color-secondary": "rgb(49, 165, 155)",
  "--background-color-secondary-active": "rgb(45, 149, 141)",
  "--background-color-secondary-inverse": "rgb(247, 253, 252)",
  "--background-color-success": "rgb(79, 172, 32)",
  "--background-color-success-active": "rgb(88, 194, 36)",
  "--background-color-success-inverse": "rgb(246, 253, 242)",
  "--background-color-warning": "rgb(230, 121, 25)",
  "--background-color-warning-active": "rgb(233, 137, 53)",
  "--background-color-warning-inverse": "rgb(253, 247, 241)",
  "--background-color-danger": "rgb(210, 45, 45)",
  "--background-color-danger-active": "rgb(216, 70, 70)",
  "--background-color-danger-inverse": "rgb(252, 242, 242)",
  "--border-color-base": "rgb(182, 177, 175)",
  "--border-color-soft": "rgb(207, 203, 201)",
  "--border-color-softer": "rgb(226, 224, 223)",
  "--border-color-active": "rgb(255, 92, 97)",
  "--border-color-primary": "rgb(255, 92, 97)",
  "--border-color-success": "rgb(79, 172, 32)",
  "--border-color-warning": "rgb(230, 121, 25)",
  "--border-color-danger": "rgb(210, 45, 45)",
  "--font-family-heading": "Circular,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif",
  "--font-family-text": "Circular,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif",
  "--font-family-code": "inconsolata, monospace",
  "--font-weight-regular": "normal",
  "--font-weight-bold": "600",
  "--line-height-base": "1.6",
  "--line-height-small": "1.3",
  "--line-height-smaller": "1.1"
}